import { useSignal } from '@preact/signals-react'
import * as $ from '../../signal/searchbox'

import { useSignals } from '@preact/signals-react/runtime'
import { useEffect } from 'react'
import { SearchResult } from '../SearchResult/SearchResult'
import { Summary } from '../Summary/Summary'
import styles from './ResultsListing.module.css'

export function ResultsListing() {
  useSignals()
  const term = useSignal($.queryTerm).value

  const results = useSignal($.searchResultsListing).value
  const focusedResult = useSignal($.focusedResultIndex).value

  let counterResults = 0

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50) {
        $.limitMultiplier.value += 1
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  if (results.value == null) {
    return null
  }

  if (results.value?.count === 0) {
    return (
      <div className={styles.searchresults__body}>
        <div className={styles.searchresults__startMessage}>
          <p>No results found for {term.value}</p>
        </div>
      </div>
    )
  }

  return results?.value?.count ? (
    <div className={styles.searchresults__body}>
      <div className={styles.searchresults__results}>
        {results.value.hits.map((hit, i) => {
          counterResults += 1

          return (
            <div key={$.currentFacet.value ? `${$.currentFacet.value}-${i}` : i}>
              <ul className={styles.searchresults__results__list}>
                <SearchResult
                  key={hit.id}
                  hit={hit}
                  isFocused={counterResults === focusedResult.value}
                  highlight={term.value?.valueOf()}
                  trimText={200}
                  className={styles.searchresults__results__list__item}
                  showIcon={false}
                />
              </ul>
            </div>
          )
        })}
      </div>
      <Summary className={styles.searchresults__summary} />
    </div>
  ) : null
}
